import { computed } from 'mobx';

/**
 * 고장부위 모델
 * @window w_tb_e014
 * @category 고장관리
 */
export class FailurePartModel2 {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 코드
   *
   * **data type** varchar(3)
   */
  readonly gregicd: string;

  /**
   * 코드
   *
   * **data type** varchar(3)
   */
  readonly regicd: string;

  /**
   * 고장부위상세명
   *
   * **data type** varchar(20)
   */
  readonly reginm: string;

  /**
   * 순번
   *
   * **data type** varchar(2)
   */
  readonly seq: string;

  /**
   * 사용유무
   *
   * **data type** char(1)
   */
  readonly useyn: string;

  /**
   * 비고
   *
   * **data type** varchar(100)
   */
  readonly remark: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  readonly inperid: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  readonly indate: string;

  /**
   * 무한반복 제거를 위한 변수
   *
   *
   */
  readonly new: string;

  readonly isnew: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.gregicd = data.gregicd || '';
    this.regicd = data.regicd || '';
    this.reginm = data.reginm || '';
    this.seq = data.seq || '';
    this.useyn = data.useyn || '';
    this.remark = data.remark || '';
    this.inperid = data.inperid || '';
    this.indate = data.indate || '';
    this.new = data.new || '';
    this.isnew = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.isnew === '1';
  }
}
